import React, { ComponentType, useEffect, useState } from "react";
import { authService } from "@/app/services/AuthService";
import PageSkeleton from "@/app/components/pageSkeleton";
import LoginPage from "../components/login/page";
import ErrorPage from "../components/errorPage";
import Locale from "@/app/locales";
import { login, User } from "../api/auth";
import { removeQueryParam } from "../utils/url";

const withAuth = <P extends object>(WrappedComponent: ComponentType<P>) => {
  return function WithAuthComponent(props: P) {
    // const { user, fetchUserInfo } = useUserStore();
    const [userInfo, setUserInfo] = useState<User>();
    const [error, setError] = useState(false);
    const [init, setInit] = useState(false);
    const [toLogin, setToLogin] = useState(false);
    const [tokenTransfer, setTokenTransfer] = useState(false);

    const handleTicketToken = async () => {
      const href = window.location.href;
      const url = new URL(href);
      const ticket = url.searchParams.get("ticket");
      if (ticket) {
        try {
          setTokenTransfer(true);
          // AuthService会自动管理登录token和cookie token
          const res = await login(ticket);
          authService.setToken(res.accessToken, res);
          setUserInfo(res.cusInfo);
          setInit(true);
        } catch (error) {
          console.log(error);
          setError(true);
        } finally {
          removeQueryParam(["ticket", "redirect"]);
          setTokenTransfer(false);
        }
      }

      if (!authService.getToken()) {
        setToLogin(true);
      } else {
        // 如果已有token，设置为登录token
        const existingToken = authService.getToken();
        if (existingToken) {
          // 重新调用setToken确保登录token被设置
          authService.setToken(existingToken);
        }
      }

      // 获取用户信息
      if (!init && authService.getToken()) {
        setInit(true);
      }
    };

    // 如果未登录，则重定向到登录页
    useEffect(() => {
      handleTicketToken();
    }, []);

    // 如果获取用户信息失败，则跳转到错误页 TODO
    if (error) {
      return <ErrorPage errorMsg={Locale.systemMsg.noUserInfo} />;
    }

    if (toLogin) {
      return <LoginPage />;
    }

    // 初始化中，显示骨架屏
    if (!init) {
      return <PageSkeleton />;
    }

    // 初始化完成，显示组件
    return (
      !tokenTransfer && <WrappedComponent {...props} userInfo={userInfo} />
    );
  };
};

export default withAuth;
